// src/shell/password.js — смяна на собствената парола от профила (грешка от
// картата, 16.10.2026: адресът POST /api/auth/change-password съществуваше,
// но екранът нямаше вход към него — новата парола я задаваше само админът).
// Успешната смяна прекратява всички сесии, включително текущата → вход.

import { el, field, input } from '../shared/dom.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { openModal, closeModal } from '../shared/modal.js';
import { MIN as PASS_MIN, passwordError } from '../../services/passwordPolicy.js';

export function changePasswordDialog(onDone) {
  const cur = input({ type: 'password', autocomplete: 'current-password' });
  const next = input({ type: 'password', autocomplete: 'new-password' });
  const again = input({ type: 'password', autocomplete: 'new-password' });
  const err = el('div', { role: 'alert' });
  const rule = el('div', { class: 'cal-hint', style: 'padding:0 0 8px', text: 'Новата парола трябва да е поне ' + PASS_MIN + ' знака — например фраза от няколко думи.' });
  const save = async () => {
    err.textContent = '';
    if (!cur.value) { err.textContent = 'Въведете текущата парола.'; cur.focus(); return; }
    { const pe = passwordError(next.value); if (pe) { err.textContent = pe; next.focus(); return; } }
    if (next.value !== again.value) { err.textContent = 'Двете нови пароли не съвпадат.'; again.focus(); return; }
    try {
      await api('/auth/change-password', { method: 'POST', body: JSON.stringify({ current_password: cur.value, password: next.value }) });
      closeModal();
      toast('Паролата е сменена. Влезте отново с новата.');
      if (onDone) onDone();
    } catch (e) { err.textContent = e.message; }
  };
  [cur, next, again].forEach((i) => i.addEventListener('keydown', (e) => { if (e.key === 'Enter') save(); }));
  openModal({
    title: 'Смяна на паролата',
    body: el('div', {}, field('Текуща парола', cur), field('Нова парола', next), rule, field('Новата парола още веднъж', again),
      el('div', { class: 'err-inline', style: 'color:var(--red);font-weight:600;min-height:1.2em' }, err)),
    foot: el('div', {},
      el('button', { class: 'btn ghost', type: 'button', text: 'Отказ', onClick: closeModal }),
      el('button', { class: 'btn', type: 'button', text: 'Смени паролата', style: 'margin-left:8px', onClick: save })),
    // Не е форма на раздел — „само преглед" не я засяга.
    allowEdit: true,
  });
}
